<template>
    <div class="relative flex flex-col">
        <div
            v-for="post in visiblePosts"
            :key="`post-${post.id}`"
            class="item bg-white rounded-[25px] flex flex-col mb-7"
        >
            <div class="item--date fle x flex-wrap md:justify-between tracking-wider py-[34px] px-7 text-base | md:text-xs 2xl:text-base | 2xl:px-[30px] 2xl:pt-[30px] | md:pt-[21px] xl:px-[22px] | md:pb-0">
                <time 
                    class="border-green-dark text-green-dark rounded-full border-[1px] px-3 | md:px-0 md:border-transparent" 
                    itemprop="datePublished" 
                    :datetime="post.date">{{ post.date }}</time>
                <span 
                    v-if="post.cat"
                    class="uppercase ml-2 new rounded-full text-white px-3 border-solid border | md:ml-0 md:bg-transparent md:px-0 md:text-black || bg-green-dark border-green-dark"
                    >{{ post.cat[0].cat_name }}</span>
            </div>

            <div v-if="post.image" class="item--img md:-mt-px md:max-h-none grow">
                <a :href="( post.external ) ? post.external.url : post.link" :target="( post.external ) ? '_blank' : ''">
                    <picture>
                        <source :srcset="post.image" media="(max-width: 767px)">
                        <img  class="rounded-b-[25px] h-full w-full object-cover" srcset="" alt="">
                    </picture>
                </a>
            </div>
            
            <div v-if="!post.image" class="item--title text-updates p-7 pt-0 pb-[61px] | 2xl:p-[30px] md:p-[22px]">
                <a :href="( post.external ) ? post.external.url : post.link" :target="post.external?.url" class="hover:text-gray hover:opacity-70 transition-all">
                    <h3>{{ post.title }}</h3>
                </a>
            </div>
        </div>
        
        <span @click="loadMore" v-show="postsAmount > postsOnLoad" class="cursor-pointer text-black bg-white rounded-[25px] text-[24px] leading-none font-light font-canela py-5 px-7 text-center">Load more</span>
    </div>
</template>
<script>
import { getBaseTransformPreset } from "@vue/compiler-core";
import { defineComponent } from "vue";
export default defineComponent({
    name: 'posts-related',
    data() {
        return {
            posts: JSON.parse(this.postsData),
            initPosts: 4,
            postsOnLoad: 4,
            // multiplier: 1,
        }
    },
    props: {
        postsData: {
            type: String,
            required: true
        },
    },
    mounted() {
    },
    methods: {
        getBageClass(cat) {
            let bageClass = '';
            switch (cat) {
                case 'new':
                    bageClass = 'bg-blue border-blue'
                    break;

                case 'press':
                    bageClass = 'bg-green-dark border-green-dark'
                    break;

                case 'insight' :
                    bageClass = 'bg-black border-black'
                    break;
                    
                default:
                    bageClass = 'bg-black border-black'
                    break;
            }

            return bageClass;
        },
        loadMore() {
            this.postsOnLoad += this.initPosts;
        },
    },
    computed: {
        postsAmount() {
            return this.posts.length;
        },
        visiblePosts() {
            return this.posts.slice(0, this.postsOnLoad);
        }
    },
    
})
</script>